import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import type { Partner } from '../../types/partners';
import { withPartnerUtm } from '../../utils/partnerLinks';
import { CtaButton } from '../ui/CtaButton';
type TryPlatformButtonProps = {
  partner: Partner;
  placement: string;
  /** Defaults to "Try Platform". Profiles use the partner-branded label. */
  label?: string;
  variant?: 'primary' | 'outline';
  size?: 'md' | 'lg' | 'xl';
  className?: string;
};

/** Outbound partner link: new tab, UTM-attributed, and tracked as `partner_try_click`. */
export function TryPlatformButton({
  partner,
  placement,
  label = 'Try Platform',
  variant = 'primary',
  size = 'md',
  className
}: TryPlatformButtonProps) {
  const destination = withPartnerUtm(partner.platformUrl, partner.slug, placement);
  return <CtaButton href={destination} variant={variant} size={size} className={className} ariaLabel={`${label} (opens in a new tab)`} event="partner_try_click" eventParams={{
    partner_id: partner.id,
    partner_name: partner.name,
    destination_url: partner.platformUrl,
    source_page: typeof window !== 'undefined' ? window.location.pathname : '',
    placement
  }} data-id="element-780" data-mp="3pq6v26fbatef">
      {label}
      <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-781" data-mp="2k11zu1thezn3" />
    </CtaButton>;
}